/* eslint-disable react/jsx-key */
import React from 'react'
import ActionLink from 'src/ui/Action/Action'

import Badge from '../Badge/Badge'
import { BadgeType } from '../../types/index'

import { Flex, Text, Grid, Button } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

type Props = {
  login: string
  isCurrentUser: boolean
  badges: BadgeType[]
}

const Badges: React.FC<Props> = ({ login, isCurrentUser, badges }) => {
  const hasBadges = badges.length > 0
  return (
    <Flex flexDirection="column" mt="3x">
      <Flex justifyContent="space-between" mb="1x">
        {(hasBadges || isCurrentUser) && (
          <Text variant="text.h5" as="h5">
            {t('Badges')}
          </Text>
        )}
        {hasBadges && (
          <ActionLink href={`/community/u/${login}/badges`}>
            {t('See all badges')}
          </ActionLink>
        )}
      </Flex>
      {isCurrentUser && !hasBadges && (
        <Flex flexDirection="column" alignItems="center">
          <ActionLink href="/community/badges/104/star-tutor">
            <Flex flexDirection="column" alignItems="center">
              <i className="fa fa-star fa-4x" style={{ color: 'grey' }} />
              <Text fontSize="xs">{t('Star Tutor')}</Text>
            </Flex>
          </ActionLink>
          <Text
            as="p"
            color="gray46"
            variant="text.paragraph"
            fontSize="sm"
            my="2x"
            textAlign="center"
            maxWidth="300px"
          >
            {t('To unlock this badge you need to fill out your profile first')}
          </Text>
          <Button
            size="large"
            type="primaryAdvanced"
            onClick={() => {
              window.location.href =
                '/community/new-topic?category=tutor-introductions'
            }}
          >
            {t('Introduce yourself')}
          </Button>
        </Flex>
      )}
      <Flex
        justifyContent="center"
        alignContent="flex-start"
        mb="1x"
        width="100%"
      >
        <Grid
          sx={{ width: '100%' }}
          columns={{
            _: 'repeat(2, 1fr)',
            tablet: 'repeat(4, 1fr)',
          }}
          gap="3x"
          alignItems="center"
          justifyItems="center"
        >
          {hasBadges &&
            badges.map((badge, index) => (
              <Badge key={`badge-${index}`} {...badge} />
            ))}
        </Grid>
      </Flex>
    </Flex>
  )
}

export default Badges
